import {create} from "zustand";
import {devtools, persist} from "zustand/middleware";
import {Configuration} from "@techheavencz/zmrzlina-admin-api";
import {add, isBefore} from "date-fns";

interface UserStoreOtherValues {
	username?: string
	expiresAt?: Date,
	loggedIn: boolean
}

interface UserStoreMethods {
	onLogin: (accessToken: string, username: string) => void
	validate: () => boolean
	logout: () => void
}

export const useUser = create<Pick<Configuration, "accessToken"> & UserStoreMethods & UserStoreOtherValues>()(
	devtools(
		persist(
			(set, get) => ({
					loggedIn: false,
					onLogin: (accessToken: string, username: string) => {
						set({
							accessToken,
							username,
							expiresAt: add(new Date(), {hours: 11, minutes: 59}),
							loggedIn: true
						})
					},
					validate: () => {
						const state = get()
						const valid = (!!state.accessToken && state.expiresAt && isBefore(new Date(), state.expiresAt!)) ?? false

						if (!valid && state.accessToken != undefined) {
							state.logout()
						} else if(valid && !state.loggedIn) {
							set({loggedIn: true})
						}

						return valid
					},
					logout: () => set({accessToken: undefined, username: undefined, expiresAt: undefined, loggedIn: false})
				}
			)
			, {
				name: "user-store",
			}
		)
	)
)